import React from 'react';
import { Skeleton } from 'antd';
import { ArrowLeftIcon, ChartIcon } from 'icons';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { isEmptyArr, useBack } from 'modules/global';
import { ResultsCard, useMyResults } from 'modules/results';

import { EmptyData, NextHead, Visible } from 'components';

const Index = () => {
  const t = useTranslations();
  const onBack = useBack('/');
  const { results, isLoading } = useMyResults();

  return (
    <>
      <NextHead title={t('meta.my_results.title')} description={t('meta.my_results.description')} />

      <div className="mx-auto my-7 min-h-screen max-w-screen p-4">
        <div onClick={onBack} className="inline-flex cursor-pointer items-center justify-start gap-2 font-semibold">
          <ArrowLeftIcon /> {t('common.ortga_qaytish')}
        </div>

        <div className="mt-5">
          <Visible
            if={isLoading}
            else={
              <Visible
                if={isEmptyArr(results)}
                else={
                  <div className="sm:col-span-3">
                    <div className="flex items-center justify-between rounded-xl bg-white p-4 shadow-sm">
                      <div className="flex items-center gap-2 text-lg font-medium">
                        <ChartIcon />
                        {t('mening_natijalarim')}
                      </div>
                    </div>

                    <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3">
                      {results?.map(result => (
                        <ResultsCard
                          key={result?.ticket_id}
                          id={result?.ticket_id}
                          type={result?.type}
                          ball={result?.percent}
                          passingBall={result?.course2?.passing_ball}
                          createdAt={result?.date}
                        />
                      ))}
                    </div>
                  </div>
                }
              >
                <EmptyData title={t('common.empty_test_data')} />
              </Visible>
            }
          >
            <div className="sm:col-span-3">
              <div className="flex items-center justify-between rounded-xl bg-white p-4 shadow-sm">
                <div className="flex items-center gap-2 text-lg font-medium">
                  <ChartIcon />
                  {t('mening_natijalarim')}
                </div>
              </div>
              <div className="mt-4 grid grid-cols-1 gap-4 sm:col-span-3 sm:grid-cols-2 lg:grid-cols-3">
                {Array.from({ length: 5 }).map((_, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Skeleton.Button key={index} active className="!w-full !h-43 !rounded-xl" />
                ))}
              </div>
            </div>
          </Visible>
        </div>
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../../messages/${locale}.json`)).default
  }
});
